module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg36-e2a377faf571017310743f726bc8731d.jpg";